<template>
  <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0">
        <div class="finanical-report-messages">
          <h1 class="section_header">Efficiency Financial Ratios</h1>
        </div>
        <div class="navbar md-toolbar md-transparent md-elevation-4 finanical-report-messages p-0">
          <nav-tabs-card no-label md-elevation="0">
            <template slot="content">
              <md-tabs md-alignment="left" class="if_card">
                <md-tab md-label="Variance" md-icon="money" class="p-0">
                  <div class="md-layout">
                    <div class="md-layout-item p-0">
                      <md-card-header class="md-card-header-icon">Variance</md-card-header>
                      <md-card-content>
                        <div class="md-layout px-4">
                          <div class="md-layout-item md-size-100">
                            <md-card class="md-card-profile">
                              <md-card-header class="md-card-header-icon">
                                <h4 class="title m-0">
                                  <div
                                    class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                  >Efficiency</div>
                                </h4>
                              </md-card-header>
                              <md-card-content>
                                <div class="md-layout">
                                  <div
                                    class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                                  >
                                    <md-table
                                      v-model="tableDataVariance"
                                      table-header-color="blue"
                                      class="profit-and-loss-table"
                                    >
                                      <md-table-row slot="md-table-row" slot-scope="{ item }">
                                        <template
                                        
                                        >
                                          <md-table-cell class="md-table-side-label">
                                            {{ item.name }}
                                            <md-tooltip md-direction="bottom">
                                              {{ item.name }}
                                            </md-tooltip>
                                          </md-table-cell>
                                          <md-table-cell
                                            v-for="key in Object.keys(
                                              item.dates
                                            )"
                                            :key="key"
                                            :md-label="key"
                                          >{{ item.dates[key] }}</md-table-cell>
                                        </template>
                                      </md-table-row>
                                    </md-table>
                                  </div>
                                </div>
                              </md-card-content>
                            </md-card>
                          </div>
                          <div
                            v-for="(chart, index) in charts"
                            :key="index"
                            class="md-layout-item md-medium-size-100 md-size-50"
                          >
                            <md-card class="md-card-profile">
                              <md-card-content>
                                <chart-card
                                  header-animation="false"
                                  :chart-data="chart.data"
                                  :chart-options="options"
                                  chart-type="Line"
                                  header-icon
                                  chart-inside-content
                                  no-footer
                                  background-color="blue"
                                >
                                  <template slot="chartInsideHeader">
                                    <h4 class="title m-0">
                                      <div
                                        class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                      >{{ chart.title }}</div>
                                    </h4>
                                    <div class="md-button-content">
                                      <md-icon
                                        v-for="(v, i) in getStars(chart.score)"
                                        :key="i"
                                      >{{ v }}</md-icon>
                                    </div>
                                  </template>
                                </chart-card>
                              </md-card-content>
                            </md-card>
                          </div>
                        </div>
                      </md-card-content>
                    </div>
                  </div>
                </md-tab>
                <md-tab md-label="Tables" md-icon="table_chart" class="p-0">
                  <div class="md-layout">
                    <div class="md-layout-item p-0">
                      <md-card-header class="md-card-header-icon">Tables</md-card-header>
                      <md-card-content>
                        <div class="md-layout px-4">
                          <div class="md-layout-item md-size-100">
                            <md-card class="md-card-profile">
                              <md-card-header class="md-card-header-icon">
                                <h4 class="title m-0">
                                  <div
                                    class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                  >Efficiency (Your Firm)</div>
                                </h4>
                              </md-card-header>
                              <md-card-content>
                                <div class="md-layout">
                                  <div
                                    class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                                  >
                                    <md-table
                                      v-model="tableDataFirm"
                                      table-header-color="blue"
                                      class="profit-and-loss-table"
                                    >
                                      <md-table-row slot="md-table-row" slot-scope="{ item }">
                                        <template
                                        
                                        >
                                          <md-table-cell class="md-table-side-label">
                                            {{ item.name }}
                                            <md-tooltip md-direction="bottom">
                                              {{ item.name }}
                                            </md-tooltip>
                                          </md-table-cell>
                                          <md-table-cell
                                            v-for="key in Object.keys(
                                              item.dates
                                            )"
                                            :key="key"
                                            :md-label="key"
                                          >{{ item.dates[key] }}</md-table-cell>
                                        </template>
                                      </md-table-row>
                                    </md-table>
                                  </div>
                                </div>
                              </md-card-content>
                            </md-card>
                          </div>
                          <div class="md-layout-item md-size-100">
                            <md-card class="md-card-profile">
                              <md-card-header class="md-card-header-icon">
                                <h4 class="title m-0">
                                  <div
                                    class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                  >Efficiency (Industry)</div>
                                </h4>
                              </md-card-header>
                              <md-card-content>
                                <div class="md-layout">
                                  <div
                                    class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                                  >
                                    <md-table
                                      v-model="tableDataIndustry"
                                      table-header-color="blue"
                                      class="profit-and-loss-table"
                                    >
                                      <md-table-row slot="md-table-row" slot-scope="{ item }">
                                        <template
                                         
                                        >
                                          <md-table-cell class="md-table-side-label">
                                            {{ item.name }}
                                            <md-tooltip md-direction="bottom">
                                              {{ item.name }}
                                            </md-tooltip>
                                          </md-table-cell>
                                          <md-table-cell
                                            v-for="key in Object.keys(
                                              item.dates
                                            )"
                                            :key="key"
                                            :md-label="key"
                                          >{{ item.dates[key] }}</md-table-cell>
                                        </template>
                                      </md-table-row>
                                    </md-table>
                                  </div>
                                </div>
                              </md-card-content>
                            </md-card>
                          </div>
                        </div>
                      </md-card-content>
                    </div>
                  </div>
                </md-tab>
              </md-tabs>
            </template>
          </nav-tabs-card>
        </div>
      </div>
</template>

<script>
import { ChartCard, NavTabsCard } from '@/components';
import { mapState } from 'vuex';
import formatData from '@/mixins/format-data';
import ratingMixin from '@/mixins/rating-mixin';

export default {
  components: {
    ChartCard,
    NavTabsCard,
  },
  mixins: [formatData, ratingMixin],
  props: ['headerData'],
  data() {
    return {
      view: 'cash-flow-solvency',
      showDialog: false,
      tableDataVariance: [],
      tableDataIndustry: [],
      tableDataFirm: [],
      charts: [],
      options: {
        lineSmooth: this.$Chartist.Interpolation.cardinal({
          tension: 10,
        }),
        axisY: {
          showGrid: true,
          offset: 40,
        },
        axisX: {
          showGrid: false,
        },
        low: 0,
        showPoint: true,
        height: '250px',
      },
    };
  },
  computed: {
    ...mapState({
      years: (state) => state.user.report.data.years,
      table: (state) => state.user.report.data.tables['ratios']['efficiency'],
      tablesInfo: (state) => state.user.report.data.tables['ratioInfo'],
      showYears: (state) => state.user.report.data.showYears,
      report: (state) => state.user.report.data,
    }),
  },
  mounted() {
    let section = this.$route.query.section;

    if (!section) {
      section = 'cash-flow-solvency';
    }

    this.switchView(section);
    let filtered_years = [];
    Object.keys(this.showYears).forEach((k, i) => {
      if (this.showYears[k]) {
        filtered_years.push(this.years[i]);
      }
    });
    if (!filtered_years.length) {
      filtered_years = this.years;
    }
    this.tableDataVariance = this.formatTable(this.table, 'variance');
    this.tableDataVariance = this.tableDataVariance.map((item) => {
      let changeDates = Object.keys(item.dates);
      changeDates = changeDates.filter((fItem) => {
        return !filtered_years.includes(fItem);
      });
      let newDates = item.dates;
      changeDates.map((el) => {
        delete newDates[el];
      });
      let obj = {
        ...item,
        dates: newDates,
      };

      return obj;
    });
    this.tableDataFirm = this.formatTable(this.table, 'firm');
    this.tableDataFirm = this.tableDataFirm.map((item) => {
      let changeDates = Object.keys(item.dates);
      changeDates = changeDates.filter((fItem) => {
        return !filtered_years.includes(fItem);
      });
      let newDates = item.dates;
      changeDates.map((el) => {
        delete newDates[el];
      });
      let obj = {
        ...item,
        dates: newDates,
      };

      return obj;
    });
    this.tableDataIndustry = this.formatTable(this.table, 'industry');
    this.tableDataIndustry = this.tableDataIndustry.map((item) => {
      let changeDates = Object.keys(item.dates);
      changeDates = changeDates.filter((fItem) => {
        return !filtered_years.includes(fItem);
      });
      let newDates = item.dates;
      changeDates.map((el) => {
        delete newDates[el];
      });
      let obj = {
        ...item,
        dates: newDates,
      };

      return obj;
    });
    if (this.report.chartData) {
      if (this.report.chartData['ratios']) {
        let chartData = this.report.chartData['ratios']['efficiency'];
        this.charts = this.formatMultipleChart(chartData);
      } else {
        let chartData = [];
      }
    } else {
      let chartData = [];
    }
  },
  watch: {
    '$route.query.section'() {
      let section = this.$route.query.section;

      if (!section) {
        section = 'cash-flow-solvency';
      }

      this.switchView(section);
    },
  },
  methods: {
    switchView: function (type) {
      this.view = type;
    },
  },
};
</script>
<style lang="scss">
.ratios-report {
  .md-button-content {
    .md-icon {
      color: #3b7ef1 !important;
    }
  }
  .financal-report-col-1 {
    display: flex;
    align-items: center;
  }

  .financal-report-col-2 {
    .access-button {
      margin-top: 18px !important;
    }

    .financal-report-col-3 {
      display: flex;
      justify-content: flex-end;
    }
  }

  .heder-titel-col-2 {
    margin-bottom: 35px;
  }

  .summary-scores-box-star {
    .md-button-content {
      .md-icon {
        color: #3b7ef1;
      }
    }

    h4 {
      margin-left: 60px;
    }
  }

  .summary-scores-box-flag {
    .md-icon {
      color: #3b7ef1;
    }

    .w-100 {
      width: 100%;
    }
  }
  .md-collapse-content {
    padding: 0 !important;
  }
  .md-collapse-title {
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0.005em;
    line-height: 16px;
  }

  h4.main-street {
    padding-top: 0;
  }
}
</style>
